/** Human labels for role keys — the single source, shared by the dashboard
 *  home + profile (was duplicated in both). */
export const ROLE_LABEL: Record<string, string> = {
  student: "Student",
  youth: "Youth",
  mentor: "Mentor",
  editor: "Editor",
  admin: "Admin",
  developer: "Developer",
};

export function roleLabel(role: string): string {
  return ROLE_LABEL[role] ?? role;
}
